import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const LOADER = /*#__PURE__*/_jsx("svg", {
  width: "46",
  height: "46",
  viewBox: "-2 -2 42 42",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(1 1)",
      strokeWidth: "3",
      children: [/*#__PURE__*/_jsx("circle", {
        strokeOpacity: ".5",
        cx: "18",
        cy: "18",
        r: "18",
        stroke: "#9e9e9e"
      }), /*#__PURE__*/_jsx("path", {
        d: "M36 18c0-9.94-8.06-18-18-18",
        stroke: "#607D8B",
        children: /*#__PURE__*/_jsx("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 18 18",
          to: "360 18 18",
          dur: "1s",
          repeatCount: "indefinite"
        })
      })]
    })
  })
});

const TRASH_ICON = /*#__PURE__*/_jsx("svg", {
  height: "16",
  viewBox: "0 0 21 21",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#2a2e3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(3 2)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "m2.5 2.5h10v12c0 1.1045695-.8954305 2-2 2h-6c-1.1045695 0-2-.8954305-2-2zm5-2c1.1045695 0 2 .8954305 2 2h-4c0-1.1045695.8954305-2 2-2z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m.5 2.5h14"
    }), /*#__PURE__*/_jsx("path", {
      d: "m5.5 5.5v8"
    }), /*#__PURE__*/_jsx("path", {
      d: "m9.5 5.5v8"
    })]
  })
});

const MENU_ICON = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  children: /*#__PURE__*/_jsx("path", {
    d: "M12 18c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z"
  })
});

const SORT_ASCENDING_ICON = /*#__PURE__*/_jsx(React.Fragment, {
  children: "\u2191"
});

const SORT_DESCENDING_ICON = /*#__PURE__*/_jsx(React.Fragment, {
  children: "\u2193"
});

const SEARCH_ICON = /*#__PURE__*/_jsx(React.Fragment, {
  children: "\u26B2"
});

const exportObj = {
  loader: LOADER,
  clearSelection: TRASH_ICON,
  columnVisibility: MENU_ICON,
  sortAscending: SORT_ASCENDING_ICON,
  sortDescending: SORT_DESCENDING_ICON,
  search: SEARCH_ICON
};
export default exportObj;